import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingProps {
  readonly label?: string;
  readonly fullScreen?: boolean;
}

const Loading = ({ label = "Loading…", fullScreen = true }: LoadingProps) => (
  <Box
    sx={{
      width: fullScreen ? "100vw" : "100%",
      height: fullScreen ? "100vh" : "100%",
      minHeight: fullScreen ? undefined : 120,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2
    }}
  >
    <CircularProgress size={28} thickness={4} />
    <Typography variant="body2" component="div" sx={{ color: "text.secondary" }}>
      {label}
    </Typography>
  </Box>
);

export default Loading;
